import { CHANNEL_RECORDING_TASK_STATE_TO_BACKGROUND_COLOR } from '../constants';
import { ChannelRecordingTaskType } from '../types';

export function getChannelRecordingTaskSpecialClassNames(item: ChannelRecordingTaskType) {
  return {
    row: CHANNEL_RECORDING_TASK_STATE_TO_BACKGROUND_COLOR[item.state],
  };
}
